'use strict';

angular.module('app')
  .service('utils', function ($injector, $window, $sce, $location, $rootScope, diviacLocalStorage, info, DestinationModel, urlMaker, gettextCatalog, selectedLanguage) {
    var utils = {},
      isLocalDev = _.find(
        ['diviaclocal', '192.168', 'localhost', 'travellocal'],
        function (str) {
          return _.includes(window.location.host, str);
        }
      ),
      isStage = _.find(['travel.padi.comingsoon.rocks'], function (str) { return _.includes(window.location.host, str) }),
      isDev = _.find(
        ['inprogress.rocks'],
        function (str) {
          return _.includes(window.location.host, str);
        }
      ),
      server = '//travel.padi.com/api/v2/travel/',
      desktop = 1400,
      tabletDesktop = 1024,
      tabletPort = 767,
      mobileLand = 500,
      currentWidth = angular.element($window)[0].innerWidth;

    if (isLocalDev) {
      server = '//travel.localhost/api/v2/travel/';
    } else if (isStage) {
      server = '//travel.padi.comingsoon.rocks/api/v2/travel/';
    } else if (isDev) {
      server = 'https://travel.padi.inprogress.rocks/api/v2/travel/';
    }

    var localStorageIsSupported = true;
    if (typeof localStorage === 'object') {
      try {
        localStorage.setItem('localStorage', 1);
        localStorage.removeItem('localStorage');
        localStorageIsSupported = true;
      } catch (e) {
        localStorageIsSupported = false;
      }
    }

    if (localStorageIsSupported && localStorage.getItem('testMode') && localStorage.getItem('testMode') === 'test') {
      server = 'https://travel.padi.inprogress.rocks/api/v2/travel/';
    }
    utils.apiURL = server;
    utils.isDev = isDev || isLocalDev;

    utils.makeURL = function (link) {
      if (typeof link !== 'string') {
        return false;
      }
      return utils.apiURL + link;
    };

    utils.isTest = function () {
      return isDev || isLocalDev || localStorage.getItem('testMode') && (localStorage.getItem('testMode') === 'test' || localStorage.getItem('testMode') === 'prod');
    };

    utils.hybridCheckout = function () {
      return localStorage.getItem('hybrid') && localStorage.getItem('hybrid') === 'true';
    };

    utils.encodeURL = function (string) {
      return string.replace(/\s/g, '_').replace(/\.|,|;/g, '-');
    };

    utils.decodeURL = function (string) {
      return string.replace(/--/g, '.,').replace(/-/g, ',').replace(/_/g, ' ');
    };

    utils.getCorrectImage = function (object, type) {
      if (!object) return false;

      if (currentWidth >= desktop) {
        return $sce.trustAsResourceUrl(object[type + 'Desktop']);
      } else if (currentWidth >= tabletDesktop && currentWidth < desktop) {
        return $sce.trustAsResourceUrl(object[type + 'TabletLand']);
      } else if (currentWidth >= tabletPort && currentWidth < tabletDesktop) {
        return $sce.trustAsResourceUrl(object[type + 'TabletPort']);
      } else if (currentWidth >= mobileLand && currentWidth < tabletPort) {
        return $sce.trustAsResourceUrl(object[type + 'MobileLand']);
      }
      
      return $sce.trustAsResourceUrl(object[type + 'MobilePort']);
    };

    utils.getHomepageBg = function (slide) {
      if (slide === 1 || !slide) {
        if (currentWidth >= desktop) {
          return '/images/bg1.jpg';
        } else if (currentWidth >= tabletDesktop && currentWidth < desktop) {
          return '/images/bg1_tablet_land.jpg';
        } else if (currentWidth >= tabletPort && currentWidth < tabletDesktop) {
          return '/images/bg1_tablet_port.jpg';
        } else if (currentWidth < tabletPort) {
          return '/images/bg1_mobile_land.jpg';
        }
      } else if (slide === 2) {
        if (currentWidth >= desktop) {
          return '/images/bg2.jpg';
        } else if (currentWidth >= tabletDesktop && currentWidth < desktop) {
          return '/images/bg2_tablet_land.jpg';
        } else if (currentWidth >= tabletPort && currentWidth < tabletDesktop) {
          return '/images/bg2_tablet_port.jpg';
        } else if (currentWidth < tabletPort) {
          return '/images/bg2_mobile_land.jpg';
        }
      } else if (slide === 3) {
        if (currentWidth >= desktop) {
          return '/images/bg3.jpg';
        } else if (currentWidth >= tabletDesktop && currentWidth < desktop) {
          return '/images/bg3_tablet_land.jpg';
        } else if (currentWidth >= tabletPort && currentWidth < tabletDesktop) {
          return '/images/bg3_tablet_port.jpg';
        } else if (currentWidth < tabletPort) {
          return '/images/bg3_mobile_land.jpg';
        }
      }
    };

    utils.shopKind = function (type) {
      var index = _.findIndex(info.shop.SHOP_KIND, function (val) {
        return val[1] === type;
      });

      if (index !== -1) {
        return info.shop.SHOP_KIND[index][0];
      }
    };

    utils.shopName = function (type) {
      var index = _.findIndex(info.shop.SHOP_KIND, function (val) {
        return val[0] == type;
      });

      if (index !== -1) {
        return info.shop.SHOP_KIND[index][1];
      }
    };

    utils.operatorSlug = function (type) {
      if (type == 'Liveaboard') {
        return 'liveaboards';
      } else if (type === 'Dive resort') {
        return 'dive-resorts';
      } else if (type === 'Dive center') {
        return 'dive-centers';
      } else if (type === 'Dive sites') {
        return 'dive-sites';
      }
    };

    utils.revertSlug = function (slug) {
      if (slug == 'liveaboards') {
        return 'Liveaboard';
      } else if (slug === 'dive-resorts') {
        return 'Dive resort';
      } else if (slug === 'dive-centers') {
        return 'Dive center';
      } else if (slug === 'dive-sites') {
        return 'Dive sites';
      }
    };

    utils.checkObjectLength = function (obj) {
      return _.isEmpty(obj);
    };

    utils.placesOptions = function (id, type) {
      id = parseInt(id);

      var index = _.findIndex(info.places[type], function (val) {
        return val[0] == id;
      });


      if (index !== -1) {
        return info.places[type][index][1];
      }
    };

    utils.selectBeds = function (kind) {
      var index = _.findIndex(info.shop.BED_TYPE, function (val) {
        return val[0] == kind;
      });


      if (index !== -1) {
        return info.shop.BED_TYPE[index][1];
      }
    };

    utils.selectExperience = function (id) {
      var index = _.findIndex(info.shop.EXPERIENCE_REQUIRED_DIVES, function (val) {
        return val[0] == id;
      });


      if (index !== -1) {
        return info.shop.EXPERIENCE_REQUIRED_DIVES[index][1];
      }
    };

    utils.visibility = function (id) {
      var index = _.findIndex(info.marineLife.VISIBILITY, function (val) {
        return val[0] === id;
      });

      if (index !== -1) {
        return info.marineLife.VISIBILITY[index][1];
      }
    };

    utils.dayDiff = function (from, to) {
      from = moment(from).format('YYYY-MM-DD');
      to = moment(to ? to : new Date()).format('YYYY-MM-DD');

      return moment(to).diff(moment(from), 'days', true);
    };

    utils.toLowerCase = function (text) {
      return text.toLocaleLowerCase();
    };

    utils.toFahrenheit = function (data, round) {
      if (!data) {
        return null;
      }

      if (round) {
        return Math.round((data * 9 / 5) + 32);
      }

      return Math.round(((data * 9 / 5) + 32) * 100) / 100;
    };

    utils.toInch = function (data, round) {
      if (!data) {
        return null;
      }

      if (round) {
        return Math.round(data / 25.4);
      }

      return Math.round((data / 25.4) * 100) / 100;
    };

    utils.toFeet = function (data, round) {
      if (!data) {
        return null;
      }

      if (round) {
        return Math.round((data * 3.28) * 100);
      }

      return Math.round((data * 3.28) * 100) / 100;
    };

    utils.toMeters = function (data) {
      if (!data) {
        return null;
      }

      return Math.round(data / 3.2808);
    };

    utils.toSquareMeters = function (data) {
      if (!data) {
        return null;
      }

      return Math.round(data * 0.09290304);
    };

    utils.toSquareFeets = function (data) {
      if (!data) {
        return null;
      }

      return Math.round(data / 0.09290304);
    };

    utils.convertUserSquarePreferenceLength = function (data, currentUnits) {
      if (!data) {
        return '—';
      }

      if ($rootScope.distance === 0 && currentUnits === 10) {
        return data + ' m<sup>2</sup>';
      } else if ($rootScope.distance === 0 && currentUnits !== 10) {
        return this.toSquareMeters(data) + ' m<sup>2</sup>';
      } else if ($rootScope.distance === 1 && currentUnits !== 10) {
        return data + ' ft<sup>2</sup>';
      }
      return this.toSquareFeets(data) + ' ft<sup>2</sup>';
    };

    utils.convertUserPreferenceLength = function (data, currentUnits) {
      if (!data) {
        return '—';
      }

      if ($rootScope.distance === 0 && currentUnits === 10) {
        return Math.round(+data) + 'm';
      } else if ($rootScope.distance === 0 && currentUnits !== 10) {
        return Math.round(this.toMeters(data)) + 'm';
      } else if ($rootScope.distance === 1 && currentUnits !== 10) {
        return Math.round(data) + 'ft';
      }
      return Math.round(this.toFeet(data)) + 'ft';
    };


    utils.capitalizeFirstLetter = function (str) {
      if (!str) {
        return str;
      }
      var firstLetter = str.substr(0, 1);

      return firstLetter.toUpperCase() + str.substr(1);
    };

    utils.bookingChoices = function (type) {
      var index = _.findIndex(info.booking.DIVE_PRODUCT_KIND, function (val) {
        return val[1].toLowerCase() === type.toLowerCase();
      });

      if (index !== -1) {
        return info.booking.DIVE_PRODUCT_KIND[index][0];
      }
    };

    utils.isMobile = function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    utils.isIOs = function () {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    };

    utils.getSource = function () {
      var ua = navigator.userAgent,
        mobile = /IEMobile|Windows Phone|Lumia/i.test(ua) ? 'w' : /iPhone|iP[oa]d/.test(ua) ? 'i' : /Android/.test(ua) ? 'a' : /BlackBerry|PlayBook|BB10/.test(ua) ? 'b' : /Mobile Safari/.test(ua) ? 's' : /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 1 : 0,
        tablet = /Tablet|iPad/i.test(ua);

      if (!mobile && ! tablet) {
        return 'Diviac Website';
      } else if (tablet && mobile) {
        return 'Diviac Tablet';
      } else if (mobile && !tablet) {
        return 'Diviac Mobile';
      }
    }

    utils.goTo = function (url, blank, event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      if (blank) {
        $window.open(url);
        return false;
      }

      $location.url({}).hash('').path(url);
    };

    utils.newSearch = function (item) {
      var searchUrl = '',
        url = '',
        type,
        location = item.area;
      console.log(item)
      if (item.modelType === 'Shop') {
        if (item.kind == 0) {
          url += '/dive-center';
        } else if (item.kind == 10) {
          // url += '/liveaboard';
          type = 'la_page'
          location = item.country;
        } else if (item.kind == 20) {
          type = 'dr_page'
          // url += '/dive-resort';
          location = item.country;
        } else if (item.kind === 30) {
          url += '/dive-sites';
        }

        searchUrl = utils.createURL(type, {
          location: location,
          slug: item.slug
        })
      } else if (item.modelType === 'Travel guides') {
        searchUrl = utils.createURL('destination', { location: item.slug });
      } else if (item.modelType === 'Fleet') {
        searchUrl = utils.createURL('fleets', { slug: item.slug });
      } else {
        if (item.searchKind) {
          if (item.searchKind === 'LA') {
            searchUrl = utils.createURL('search_la', { slug: item.slug });
          } else if (item.searchKind === 'DR') {
            searchUrl = utils.createURL('search_dr', { slug: item.slug });
          } else if (item.searchKind === 'DC') {
            searchUrl = utils.createURL({type: 'dive-centers', slug: item.slug});
          } else if (item.searchKind === 'DS') {
            searchUrl = utils.createURL({type: 'dive-sites', slug: item.slug});
          } else if (item.searchKind === 'Group') {
            searchUrl = utils.createURL('marketplace_search', {slug: item.slug});
          }
        } else {
          if (item.modelType === 'Geo-Location') {
            searchUrl = utils.createURL('search_dr', { slug: item.slug });
          } else {
            searchUrl = utils.createURL(item.hasDiveResorts ? 'search_dr' : 'search_la', { slug: item.slug });
          }
        }
      }

      $location.path(searchUrl).hash('').search({});
    };

    utils.closePopup = function () {
      jQuery.fancybox.close();
    };

    utils.shareThis = function () {
      stButtons.makeButtons();
    };


    utils.generateHighlightsUrl = function (slug, model) {
      var type;

      if (model.kind == 0) {
        type = 'dive-centers';
      } else if (model.kind == 10) {
        type = 'liveaboards';
      } else if (model.kind == 20) {
        type = 'dive-resorts';
      } else if (model.kind === 30) {
        type = 'dive-sites';
      }
            
      url = urlMaker.searchPageUrl({type: type, slug: slug});

      if (model.point && model.point.length) {
        url += '?highlight=' + model.point[1] + ',' + model.point[0];
        url += '&highlightId=' + model.id;
        url += '&highlight-title=' + model.title;
      }

      return url;
    };

    utils.findInObject = function (obj, id) {
      return _.find(obj, {
        id: id
      });
    };


    utils.plus = function (value) {
      if (_.isUndefined(value) || _.isNaN(value) || value.length === 0) {
        return 0;
      }
      var val = parseInt(_.clone(value));

      if (val >= 99) {
        return 99;
      }
      val = val + 1;

      return val;
    };

    utils.minus = function (value) {
      if (!value) {
        return 0;
      }
      if (value <= 0) {
        return 0;
      }
      value -= 1;
      return value;
    };

    utils.randomRange = function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    utils.bindItinerary = function (days) {
      if (!days.length) {
        return [];
      }

      var notEmpty = _.filter(days, function (val) {
        return !_.isEmpty(val.description);
      });

      if (!notEmpty.length) {
        return [];
      }

      if (notEmpty.length > 1) {
        for (var i = 0; i < notEmpty.length; i++) {
          if (i === 0) {
            notEmpty[i].dayStart = 1;

            if (notEmpty[i + 1]) {
              notEmpty[i].dayFinish = notEmpty[i + 1].dayStart - 1;
            }
          } else if (i !== 0 && notEmpty[i + 1]) {
            notEmpty[i].dayFinish = notEmpty[i + 1].dayStart - 1;
          } else if (i !== 0 && !notEmpty[i + 1]) {
            notEmpty[i].dayFinish = days.length;
          }
        }

        return notEmpty;
      } else {
        return [{
          dayStart: 1,
          dayFinish: days.length,
          description: _.clone(notEmpty[0]).description
        }];
      }
    };
    // Shit, but it's really needed here
    utils.setCanonical = function (url) {
      if (!url) {
        return 1;
      }

      var canonicalLink = $('link[rel="canonical"]');
      if (canonicalLink.length) {
        canonicalLink.attr('href', url);
      } else {
        $('head').append('<link rel="canonical" href="' + url + '" />');
      }
    }

    utils.setPrevNextUrl = function (page, next) {
      var url = window.location.origin + window.location.pathname,
        prevLink = $('link[rel="prev"]'),
        nextLink = $('link[rel="next"]');

      if (page > 1) {
        if (prevLink.length) {
          prevLink.attr('href', url + '?page='+ (page - 1));
        } else {
          $('head').append('<link rel="prev" href="' + url + '?page='+ (page - 1) + '" />');
        }
      } else {
        prevLink.remove();
      }

      if (next) {
        if (nextLink.length) {
          nextLink.attr('href', url + '?page='+ (page + 1));
        } else {
          $('head').append('<link rel="next" href="' + url + '?page='+ (page + 1) + '" />');
        }
      } else {
        nextLink.remove();
      }
    }

    utils.setNoIndex = function (noIndex, follow) {
      if (noIndex) {
        $('meta[content="noindex"]').remove();

        return 1;
      }

      var indexTag = $('meta[content="noindex"]');

      if (indexTag.length) {
        return 1;
      } else if (follow) {
        $('head').append('<meta name="robots" content="noindex, follow" />');
      } else {
        $('head').append('<meta name="robots" content="noindex" />');
      }
    };

    utils.setFragment = function (fragment) {
      if (!fragment) {
        $('head').append('<meta name="fragment" content="!" />');
      }
    };

    utils.getCookie = function (name) {
      var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    utils.setCookie = function (name, value, options) {
      options = options || {};

      var expires = options.expires;

      if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + "=" + value;

      for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += "=" + propValue;
        }
      }

      document.cookie = updatedCookie;
    };


    utils.calculatePercent = function (first, second) {
      var saleQty = first / second,
        sale = 100 - (saleQty * 100);

      // if (sale < 10) {
      //     return +(Math.round(sale + 'e+2') + 'e-2');
      // }

      return Math.round(sale);
    };

    utils.tilesLimit = function (limit) {
      var windowWidth = window.innerWidth;
      if (windowWidth > 1400)
        return limit.pc;
      else if (windowWidth < 1400 && windowWidth >= 1024)
        return limit.tabletLand
      else if (windowWidth < 1024 && windowWidth >= 768)
        return limit.tabletPort
      else(windowWidth < 768)
      return limit.mobile;
    };

    utils.getTextFromInfo = function (id, category, option) {
      var element = info[category][option],
        index = _.findIndex(element, function (val) {
          return val[0] == id;
        });


      if (index !== -1) {
        return element[index][1];
      }
    };

    utils.getPayedPerLabelLA = function (pricing, qty) {
      var labelsArray = info.shop.LIVEABOARD_EXTRA_PAYED_PER,
        text = '',
        labelIndex = -1;

      if (qty > 1) {
        labelsArray = info.shop.LIVEABOARD_EXTRA_PAYED_PER_PLURAL;
      }

      labelIndex = _.findIndex(labelsArray, function (val) {
        return val[0] === +pricing.payedPer;
      });

      // define prefix based on quantity
      var prefix = gettextCatalog.getString('per');
      if (qty > 0) {
        prefix = gettextCatalog.getString('for') + ' ' + qty;
      }

      if (labelIndex !== -1) {
        if (+pricing.payedPer <= 15) {
          text = prefix + ' ' + labelsArray[labelIndex][1].toLowerCase();
        } else if (+pricing.payedPer === 42 || +pricing.payedPer === 46 || +pricing.payedPer === 49) {
          //  transfers per person
          text = prefix + ' ' + gettextCatalog.getPlural(qty || 1, 'person', 'persons');
        } else if (+pricing.payedPer === 44 || +pricing.payedPer === 48 || +pricing.payedPer === 55) {
          //  transfers per vehicle
          text = prefix + ' ' + gettextCatalog.getPlural(qty || 1, 'vehicle', 'vehicles');
        } else {
          text = prefix + ' ' + labelsArray[labelIndex][1].split('/')[0].toLowerCase();
        }
      }

      return text;
    };

    utils.getPayedPerLabel = function (pricing, qty) {
      var labelsArray = info.shop.RESORT_EXTRA_PAYED_PER,
        text = '',
        labelIndex = -1;

      if (qty > 1) {
        labelsArray = info.shop.RESORT_EXTRA_PAYED_PER_PLURAL;
      }

      labelIndex = _.findIndex(labelsArray, function (val) {
        return val[0] === +pricing.payedPer;
      });

      // define prefix based on quantity
      var prefix = gettextCatalog.getString('per');
      if (qty > 0) {
        prefix = gettextCatalog.getString('for') + ' ' + qty;
      }

      if (labelIndex !== -1) {
        if (+pricing.payedPer <= 15) {
          text = prefix + ' ' + labelsArray[labelIndex][1].toLowerCase();
        } else if (+pricing.payedPer === 51 || +pricing.payedPer === 53 || +pricing.payedPer === 56) {
          //  transfers per person
          text = prefix + ' ' + gettextCatalog.getPlural(qty || 1, 'person', 'persons');
        } else if (+pricing.payedPer === 52 || +pricing.payedPer === 54 || +pricing.payedPer === 57) {
          //  transfers per vehicle
          text = prefix + ' ' + gettextCatalog.getPlural(qty || 1, 'vehicle', 'vehicles');
        } else {
          text = prefix + ' ' + labelsArray[labelIndex][1].split('/')[0].toLowerCase();
        }
      }

      return text;
    };

    utils.getPayedOnPremiseLabel = function (pricing, type) {
      var text = '';
      if (pricing.payedInAdvance === false) {
        if (type === 'LA') {
          text = gettextCatalog.getString('To be paid on board');
        } else {
          text = gettextCatalog.getString('To be paid at the') + ' ';

          if (+pricing.section === 10 || +pricing.section === 40) {
            text += gettextCatalog.getString('dive center');
          } else {
            text += gettextCatalog.getString('resort');
          }
        }
      }
      return text;
    };

    utils.genereateMonthPicker = function () {
      var monthCount = moment().month(),
        numberOfMonthes = 24,
        time = [{
          id: '30-days',
          title: gettextCatalog.getString('Next 30 days'),
          from: moment().format('YYYY-MM-DD'),
          to: moment().add('30', 'd').format('YYYY-MM-DD'),
        }];

      while (monthCount < numberOfMonthes + moment().month() + 1) {
        time.push({
          id: moment().month(monthCount).locale(selectedLanguage).format('MMM-YYYY'),
          from: moment().month(monthCount).subtract(0, 'months').startOf('month').format('YYYY-MM-DD'),
          to: moment().month(monthCount).subtract(0, 'months').endOf('month').format('YYYY-MM-DD'),
          title: moment().month(monthCount).locale(selectedLanguage).format("MMMM YYYY"),
        });
        monthCount++;
      }

      return time;
    };

    utils.removeSpaces = function (string) {
      return string.replace(/\s/g,'');
    };

    // utils.isDateInRange = function(dateFrom,dateTo) {
    //     var today = moment(moment((new Date()).toUTCString()).utc().format('YYYY-MM-DD')),
    //         from = moment((new Date(dateFrom)).toUTCString()).format('YYYY-MM-DD'),
    //         to = moment((new Date(dateTo)).toUTCString()).format('YYYY-MM-DD');

    //     return today.isBetween(from,to, null, '[)');
    // };

    utils.changePrice = function (obj) {
      var test = diviacLocalStorage.get('abTestLA');

      if (+test === 1) {
        if (obj.price) {
          obj.price = obj.diverPrice;
          obj.compareAtPrice = obj.diverCompareAtPrice;
          obj.grossPrice = obj.diverPrice;
        } else if (obj.minimalPrice) {
          obj.minimalPrice = obj.diverPrice;
        }
      }
    };

    utils.displayProperRating = function (shopKind, diviacRating, tripAdvisor, scubaTribe, type, resortRating) {
      if (!tripAdvisor) {
        tripAdvisor = 0;
      }

      if (!diviacRating) {
        diviacRating = 0;
      }

      if (!scubaTribe) {
        scubaTribe = 0;
      }

      if (!resortRating) {
        resortRating = 0;
      }

      var minimumReviewCount = shopKind === 10 ? 0 : 3;

      if (type === 'diviac' && diviacRating > minimumReviewCount && scubaTribe < 5 && tripAdvisor <= 5 && resortRating <= 5) {
        return true;
      } else if (type==='resort' && resortRating > 5 && tripAdvisor <= 5) {
        return true;
      } else if (type === 'ta' && tripAdvisor > 5) {
        return true;
      } else if (type === 'scuba' && scubaTribe > 5 && tripAdvisor <= 5 && resortRating <= 5) {
        return true;
      }

      return false;
    }

    utils.getCurrencyTitle = function (key) {
      return $rootScope.currencyTitles[key];
    }

    utils.catchError = function (error) {
      if (error.data.nonFieldErrors) {
        $rootScope.showNotify(error.data.nonFieldErrors[0]);
      } else {
        $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
      }
    }

    utils.getTimeOptions = function (type) {
      var index = _.findIndex(info.shop.ITINERARY_TIME_APPROXIMATION, function (val) {
        return val[0] === type;
      });

      if (index !== -1) {
        return info.shop.ITINERARY_TIME_APPROXIMATION[index][1];
      }
    }

    utils.toggleAll = function (array, type) {
      _.each(array, function (v,k) {
        array[k] = type;
      });
    }

    utils.getOrderStatus = function (id) {
      var index = _.findIndex(info.checkout.ORDER_STATUS_LIST_FOR_INTRANET, function (val) {
        return val[0] === id;
      });

      if (index !== -1) {
        return info.checkout.ORDER_STATUS_LIST_FOR_INTRANET[index][1];
      }
    }

    utils.bindLogistic = function (descriptions) {
      _.each(descriptions, function (v) {
        if (v.section === 10) {
          if (!descriptions.beforeTrip) {
            descriptions.beforeTrip = [];
          }

          descriptions.beforeTrip.push(v);
        } else if (v.section === 20) {
          if (!descriptions.onBoard) {
            descriptions.onBoard = [];
          }

          descriptions.onBoard.push(v);
        } else if (v.section === 30) {
          if (!descriptions.afterTrip) {
            descriptions.afterTrip = [];
          }

          descriptions.afterTrip.push(v);
        }
      });

      return descriptions;
    }

    utils.selectCertification = function (id) {
      var index = _.findIndex(info.shop.ITINERARY_CERTIFICATION_CHOICES, function (val) {
        return val[0] == id;
      });


      if (index !== -1) {
        return info.shop.ITINERARY_CERTIFICATION_CHOICES[index][1];
      }
    }

    utils.md5 = function (s){
      function L(k,d){return(k<<d)|(k>>>(32-d))}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H)}if(I|d){if(x&1073741824){return(x^3221225472^F^H)}else{return(x^1073741824^F^H)}}else{return(x^F^H)}}function r(d,F,k){return(d&F)|((~d)&k)}function q(d,F,k){return(d&k)|(F&(~k))}function p(d,F,k){return(d^F^k)}function n(d,F,k){return(F^(d|(~k)))}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F)}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F)}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F)}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F)}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]| (G.charCodeAt(H)<<d));H++}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2)}return k}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x)}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128)}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128)}}}return d}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g)}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase()
    }

    utils.formattedRoomsText = function (option) {
      var divers,students, and, nonDivers, rooms

      if (option) {
        if (option.title) return option.title
        if (!option.divers && !option.nonDivers && !option.students) return '—'
        if (!option.students) option.students = 0

        divers = gettextCatalog.getPlural(option.divers, '{{ count }} diver', '{{ count }} divers', {count: option.divers});
        students = gettextCatalog.getPlural(option.students, '{{ count }} student', '{{ count }} students', {count: option.students});
        and =  ' ' + gettextCatalog.getString('and') + ' ';
        nonDivers = gettextCatalog.getPlural(option.nonDivers, '{{ count }} non-diver', '{{ count }} non-divers', {count: option.nonDivers})
        rooms = gettextCatalog.getPlural(option.rooms, '{{ count }} room', '{{ count }} rooms', {count: option.rooms})
                
        if (option.divers === 0) {
          divers = " ";
        } else if (option.divers > 0 && option.students > 0 && option.nonDivers > 0) {
          students = ', ' + students
        }

        if (option.students === 0) {
          students = '';
        }

        if (option.nonDivers === 0) {
          nonDivers = " ";
        }

        return divers + (!option.nonDivers && option.divers && option.students ? and : '') + students + (option.nonDivers && (option.divers || option.students) ? and : '') + nonDivers + ' ' + gettextCatalog.getString('in') + ' ' + rooms;
      } 

      return ''
    }



    utils.isDateInRange = function (currentDate, dateFrom, dateTo) {
      var current = moment(currentDate),
        from = moment(dateFrom).format('YYYY-MM-DD'),
        to = moment(dateTo).format('YYYY-MM-DD');
      return current.isBetween(from,to, null, '[)');
    }


    utils.setRoomParams = function (roomId, filter) {
      var config = $injector.get('config'),
        roomParams = _.find(config.roomsAndGuests, { id: roomId || 'auto' }),
        totalGuests = 0,
        divers = 0,
        nonDivers = 0,
        students = 0,
        diversByRoom = [],
        nonDiversByRoom = [],
        studentsByRoom = [],
        guests = [];
                
      if (roomParams.details) {
        _.each(roomParams.details, function (val) {
          guests.push(val.nonDivers + val.divers + val.students);

          diversByRoom.push(val.divers)
          nonDiversByRoom.push(val.nonDivers)
          studentsByRoom.push(val.students)
          students += val.students
          divers += val.divers
          nonDivers += val.nonDivers
          
          totalGuests += val.nonDivers + val.divers + val.students;
        });
      } else {
        guests = roomParams.divers + roomParams.nonDivers + roomParams.students;
        nonDivers = roomParams.nonDivers;
        diversByRoom = roomParams.divers;
        nonDiversByRoom = roomParams.nonDivers;
        studentsByRoom = roomParams.students;
        students += roomParams.students
        divers += roomParams.divers
        nonDivers += roomParams.nonDivers
        totalGuests = guests;
      }
            
      filter.to = moment(filter.from).add(filter.duration,'days').format('YYYY-MM-DD');

      if (filter.from && filter.to) {
        diviacLocalStorage.set('duration', filter.duration);
        diviacLocalStorage.set('date', [filter.from,filter.to]);
        diviacLocalStorage.set('roomParams', roomParams);
      }
            
      return {
        filterParams: {
          date_0: filter.from,
          date_start: filter.from,
          dateTo: filter.to,
          date_1: moment(filter.from).add(filter.duration,'days').format('YYYY-MM-DD'),
          // date_1: filter.duration > 1 ? moment(filter.from).add(filter.duration,'days').format('YYYY-MM-DD') : filter.from,
          nights: filter.duration,
          guests: guests,
          totalGuests: totalGuests,
          divers: divers,
          students: students,
          nonDivers: nonDivers,
          diversByRoom: diversByRoom,
          nonDiversByRoom: nonDiversByRoom,
          studentsByRoom: studentsByRoom
        },
        roomParams: roomParams                
      }
    }

    utils.selectRooms = function (data, roomsAndGuests, filter) {
      var elem = {
        id: 'auto',
        divers: 0,
        students: 0,
        nonDivers: 0,
        rooms: 0
      }
      var rooms = _.filter(data, function (val) {
        return val.divers || val.nonDivers || val.students;
      });

      _.each(rooms, function (val) {
        if (val.divers || val.students || val.nonDivers) {
          elem.divers += val.divers;
          elem.nonDivers += val.nonDivers;
          elem.students += val.students;
          elem.rooms++;
        }
      });

      if (elem.rooms) {
        elem.details = rooms;
        roomsAndGuests[2] = elem;
      }

      filter = 'auto';

      return {
        roomsAndGuests: roomsAndGuests,
        filter: filter
      }
    }

    utils.validateCardDate = function (m, y) {
      if (!m && !y) {
        return false;
      }

      if (m && !y || !m && y) {
        return true;
      }
            
      if (moment().isSameOrBefore(moment().year('20' + y).month(+m - 1))) {
        return false;
      }
            
      return true;
    }

    utils.hideLoader = function () {
      if (window.requireRedirect && 
                window.requireRedirect !== selectedLanguage && 
                utils.isBotCrawler() === false) {
        return false;
      }
      angular.element(document.getElementById('first-loader')).remove();
    }

    utils.isBotCrawler = function () {
      return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)
    }

    utils.generateAffiliateUrl = function () {
      var query = '?',
        origin = window.location.origin.search('localhost') !== -1 ? 'https://travel.padi.inprogress.rocks/' : window.location.origin,
        affiliateQueries = [
          'aid',
          'utm_campaign',
          'utm_source',
          'utm_medium',
          'utm_content'
        ]

      if (window.location.search) {
        var queryParams = $location.search(),
          cleanedQueryParams = _.omit(queryParams, function (val, key) {
            return affiliateQueries.indexOf(key) !== -1
          })
                    
        query += jQuery.param(cleanedQueryParams, true)
      }

      if (query.length > 1) {
        query += '&'
      }

      query += 'aid=' + $rootScope.user.affiliate.memberNumber + '&utm_campaign=ww-all-all-affiliates-shops&utm_source=affiliate_'+ $rootScope.user.affiliate.memberNumber +'&utm_medium=link&utm_content=direct';

        
      return origin + window.location.pathname + query;
    }

    utils.getAffiliateId = function () {
      var aid = utils.getCookie('padi_aid'),
          cid = utils.getCookie('padi_cid');

      if ($rootScope.user && $rootScope.user.affiliate) {
        return {
          aid: $rootScope.user.affiliate.memberNumber
        }
      } else if ($rootScope.user && $rootScope.user.isStaff) {
        return {};
      } else if (aid) {
        return {
          aid: aid,
          cid: cid,
        };
      }
            
      return {}
    }

    utils.showCancellationDate = function (date) {
      return moment().add(date,'d').locale('en').format('DD MMM YYYY')
    }

    utils.setLanguage = function (lang) {
      utils.setCookie('travel_language', lang, { path: '/', domain: window.location.href.search('padi.com') !== -1 ? '.padi.com' : '.padi.inprogress.rocks', expires: 3600 * 24 * 7 /* 7 days */ })
    }

    utils.generateLangUrl = function (lang) {
      if (!$rootScope.routeName) {
        return window.createUrl('homepage', lang)
      }

      var url = window.createUrl($rootScope.routeName, lang);

      if (url.search(':') !== -1) {
        var splittedUrl = url.split('/'),
          isTranslatedUrl = window.location.pathname.match(/^\/[a-z]{2,3}\//),
          splittedCurrentRoute = window.location.pathname.split('/'),
          generatedUrl = ''

        _.each(splittedUrl, function (val, index) {
          if (val) {
            if (val[0] === ':') {
              // GAVNOCODE
              if ($rootScope.allLanguageSlugs && val.search('slug') > 0) {
                generatedUrl += '/' + $rootScope.allLanguageSlugs[lang]
              } else if ($rootScope.itineraryLocationTranslations && val.search('location') > 0) {
                generatedUrl += '/' + $rootScope.itineraryLocationTranslations[lang]
              } else {
                if (isTranslatedUrl && lang === 'en') {
                  generatedUrl += '/' + splittedCurrentRoute[index + 1]
                } else if (!isTranslatedUrl && lang !== 'en') {
                  generatedUrl += '/' + splittedCurrentRoute[index - 1]
                } else {
                  generatedUrl += '/' + splittedCurrentRoute[index]
                }
              }
            } else {
              generatedUrl += '/' + val;
            }
          }
        });

        url = generatedUrl
      }

      return url
    }

    utils.selectedLanguage = function () {
      var fullLanguage = 'English'
      switch(selectedLanguage) {
      case 'de':
        fullLanguage = 'Deutsch'
        break
      case 'es':
        fullLanguage = 'Español'
        break
      case 'it':
        fullLanguage = 'Italiano'
        break
      case 'nl':
        fullLanguage = 'Nederlands'
        break
      case 'fr':
        fullLanguage = 'Français'
        break
      }

      return fullLanguage
    }

    utils.createURL = function (path, params, query) {
      if (!path) {
        return ''
      }

      if (path.search('https://') !== -1 || path.search('http://') !== -1 || path[0] === '/') {
        return path
      }

      var route = window.createUrl(path, selectedLanguage);
            
      if (params) {
        _.each(params, function (val, key) {
          route = route.replace(':' + key, val);
        })
      }

      if (query) {
        if (route[route.length - 1] === '/') {
          route = route.slice(0,-1) + query
        } else {
          route += query
        }
      }

      return route
    }

    utils.setTransferIcon = function (payedPer){
      var arrow = {};
      //51,52 = from the resort; 53,54 = to the resort, 56,57 = to and from the resort;
      if(payedPer == 51 || payedPer == 52) {
        arrow['icon-transfer-from'] = true
      } else if (payedPer == 53 || payedPer == 54) {
        arrow['icon-transfer-to'] = true
      } else if (payedPer == 56 || payedPer == 57) {
        arrow['icon-return'] = true
      }
            
      return arrow;
    }

    utils.isBelongsTo = function (belongsTo, groupIdentifier) {
      var item = _.find(info.inclusionGroups, {id: +belongsTo});

      return item && item.unique_identifier === groupIdentifier ? item : false
    }

    utils.getInclusionGroupsId = function (groupIdentifier) {
      var item = _.find(info.inclusionGroups, { unique_identifier: groupIdentifier});

      return item ? item.id : false
    }

    utils.getWishlistTranslatedTooltip = function (isWishlist){
      return isWishlist ? gettextCatalog.getString("Click to remove from your wishlist") : gettextCatalog.getString("Click to add to your wishlist") ;
    }

    utils.occupancyString = function (occupancy, rooms) {
      var occupancyLabels = {
        /// For example: Single occupancy in rooms 1, 2, 3
        1: gettextCatalog.getPlural(rooms.length, 'Single occupancy in room', 'Single occupancy in rooms'),
        /// For example: Double occupancy in room 1
        2: gettextCatalog.getPlural(rooms.length, 'Double occupancy in room', 'Double occupancy in rooms'),
        /// For example: Tripple occupancy in rooms 1, 2, 3
        3: gettextCatalog.getPlural(rooms.length, 'Tripple occupancy in room', 'Tripple occupancy in rooms')
      }
            
      return occupancyLabels[occupancy] || gettextCatalog.getPlural(rooms.length, '{{ count }}x occupancy in room', '{{ $count }}x occupancy in rooms', {
        count: occupancy
      })
    }

    utils.occupancyStringLa = function (occupancy) {
      var occupancyLabels = {
        1: gettextCatalog.getString('Single occupancy'),
        2: gettextCatalog.getString('Double occupancy'),
        3: gettextCatalog.getString('Tripple occupancy')
      }
            
      return occupancyLabels[occupancy] || gettextCatalog.getPlural(occupancy, '{{ count }}x occupancy', '{{ $count }}x occupancy in rooms', {
        count: occupancy
      })
    }

    utils.showItemPrice = function (pricing, qty, currency) {
      var price = pricing.priceGross;
            
      if (pricing.payedInAdvance === false && !price) {
        return pricing.extraValue
      }

      return $rootScope.setValue((qty || 1) * price, pricing.currency || currency,0,0,0,true); 
    }

    utils.isStaff = function () {
      var user = diviacLocalStorage.get('user');

      return user ? user.isStaff : false;
    }

    utils.makeABTest = function () {
      if (Math.random() >= 0.5) {
        return true;
      } else {
        return false;
      }
    }

    utils.compareAll = function() {
      var len = arguments.length;
      for (var i = 1; i< len; i++){
          if (arguments[i] === null || arguments[i] !== arguments[i-1])
            return false;
      }
      return true;
    }

    // check's if trip start date is earlier than N days from today
    utils.isLastMinuteBooking = function(date) {
      var days = 21,
        dateNow = moment(),
        tripStartDate = moment(date);
      
      return (tripStartDate.diff(dateNow, 'days') + 1) <= days
    }

    return utils;

  });
